<template>
  <div id="services">
    <div class="container">

      <div class="page-title">
        <div class="name">{{ name }}</div>
        <button class="save btn btn-primary" @click="save">{{ $t('save') }}</button>
      </div>

      <Tabs>

        <TabSection :title="$t('services.title')">
          <div class="group">
            <label>
              <span>{{ $t("services.availability") }}</span>
              <Tooltip :text="$t('services.availability_tooltip')" />
            </label>
          </div>
          <div class="columns">
            <div class="column">
              <div class="service">
                <span class="service-name">{{ $t("services.online_ordering") }}</span>
                <select v-model="activated.onlineOrdering">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service">
                <span class="service-name">{{ $t("services.kiosk") }}</span>
                <select v-model="activated.kiosk">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service">
                <span class="service-name">{{ $t("services.app") }}</span>
                <select v-model="activated.mobileApp">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service" v-if="$store.getters.loggedUserHasSuperAdmin">
                <span class="service-name">{{ $t("services.dispatch") }}</span>
                <select v-model="activated.dispatch">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service">
                <span class="service-name">{{ $t("services.on_site_ordering") }}</span>
                <select v-model="activated.onSiteOrdering">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
            </div>
            <div class="column">
              <div class="service">
                <span class="service-name">{{ $t("services.menuboard") }}</span>
                <select v-model="activated.menuBoard">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service">
                <span class="service-name">{{ $t("services.catering") }}</span>
                <select v-model="activated.catering">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service">
                <span class="service-name">{{ $t("services.user_management") }}</span>
                <select v-model="activated.userManagement">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service">
                <span class="service-name">{{ $t("services.qr_payment") }}</span>
                <select v-model="activated.payAtTheTable">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <div class="service">
                <span class="service-name">{{ $t('ticket.voucher_activated') }}</span>
                <select v-model="aimsVouchersActivated">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
            </div>
          </div>
        </TabSection>

        <TabSection :title="$t('branch.extended_profile_fields.title')" class="extended-fields"
          v-if="$store.getters.loggedUserHasSuperAdmin && activated.onlineOrdering">
          <div class="description">{{ $t('branch.extended_profile_fields.description') }}</div>
          <div class="fields">
            <div class="field" v-for="(field, fieldIndex) of supportedProfileFields">
              <div class="title">
                {{ $t('branch.extended_profile_fields.' + field.name) }}
              </div>
              <div class="options">
                <input type="checkbox" :id="'chk_field_onRegister_' + fieldIndex" v-model="field.visibleOnRegister">
                <label :for="'chk_field_onRegister_' + fieldIndex">{{ $t('branch.extended_profile_fields.register')
                }}</label>
                <input type="checkbox" :id="'chk_field_required_' + fieldIndex" v-model="field.required">
                <label :for="'chk_field_required_' + fieldIndex" v-show="field.visibleOnRegister">{{
                  $t('branch.extended_profile_fields.required') }}</label>
              </div>
            </div>
          </div>
        </TabSection>

      </Tabs>

      <div class="footer-actions">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    name: "BranchServices",

    data() {
      return {
        supportedProfileFields: [
          {
            name: 'firstName',
            required: false,
            visibleOnRegister: false
          }, {
            name: 'birthDate',
            required: false,
            visibleOnRegister: false
          }, {
            name: 'phoneNumber',
            required: false,
            visibleOnRegister: false
          }
        ],
        extendedProfileFields: [],
        name: null,
        id: null,
        aimsVouchersActivated: false,
        activated: {
          onlineOrdering: false,
          onSiteOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          catering: false,
          userManagement: false,
          payAtTheTable: false,
          dispatch: false
        },
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "services.title";
      this.$store.state.pageIcon = "/icon/services.svg";
      this.id = this.$route.query.branch;

      if (this.id) {
        showSpinner();
        await this.loadBranch();
        hideSpinner();
      }
    },

    methods: {
      ...mapActions(["getBranch", "getBranchContacts", "saveBranch", "saveBranchContacts"]),

      async loadBranch() {
        let response = await this.getBranch({ branchId: this.id, fallback: false });
        if (response) {
          this.name = response.name;
          this.extendedProfileFields = response.extendedProfileFields || [];
          this.aimsVouchersActivated = response.aimsVouchersActivated || false;
          this.activated = {
            onlineOrdering: response.onlineOrdering.activated || false,
            kiosk: response.kiosk.activated || false,
            mobileApp: response.mobileApp.activated || false,
            menuBoard: response.menuBoard.activated || false,
            onSiteOrdering: response.onSiteOrdering || false,
            catering: response.onlineOrdering.catering ? response.onlineOrdering.catering.activated : false,
            userManagement: response.userManagement || false,
            payAtTheTable: response.payAtTheTable.activated || false,
            dispatch: response.dispatch || false
          };
          this.loadSupportedProfileFields();
        } else {
          console.log("erreur de fetch branch", response);
          toast(this.$t("error.no_server"), "error");
        }
      },

      async save() {
        let data = {
          extendedProfileFields: this.getExtendedProfileFields(),
          aimsVouchersActivated: this.aimsVouchersActivated,
          activated: this.activated
        };
        showSpinner();
        let response = await this.saveBranch({ branchId: this.id, augment: 'backend', data });
        hideSpinner();
        if (response) {
          toast(this.$t("branch.success"), "success");
          this.$store.commit("updateBranch", response);
        } else {
          console.log("erreur de fetch branch", response);
          toast(this.$t("error.no_server"), "error");
        }
      },

      getExtendedProfileFields() {
        let fields = JSON.parse(JSON.stringify(this.supportedProfileFields));
        let data = [];
        for (let field of fields.filter(f => f.visibleOnRegister)) {
          data.push(field);
          if (field.name === 'firstName') {
            data.push({
              name: 'lastName',
              required: field.required,
              visibleOnRegister: field.visibleOnRegister
            });
          }
        }
        return data;
      },

      loadSupportedProfileFields() {
        for (let field of this.supportedProfileFields) {
          let found = this.extendedProfileFields.find(f => f.name === field.name);
          if (found) {
            field.visibleOnRegister = found.visibleOnRegister;
            field.required = found.required;
          } else {
            // TODO this would be a custom field. unsupported at the moment
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  #services {
    display: flex;
  }

  .service {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    select {
      width: 150px;
    }
  }

  .service-name {
    flex-grow: 1;
    font-weight: 500;
  }

  .fields {
    display: flex;

    .field:not(:last-child) {
      margin-right: 30px;
      border-right: 1px solid #f1f1f1;
      padding-right: 30px;
    }

    .title {
      margin-bottom: 10px;
      font-weight: bold;
      font-size: 14px;
    }

    label {
      margin-bottom: 5px;
    }
  }

  .extended-fields {
    .description {
      margin-bottom: 20px;
      color: #888;
    }
  }
</style>